import * as React from 'react';
import styled from 'styled-components';
import { useTheme, withThemeProvider } from '@narvar/nth-hook-theme';
import { LocationHours } from '../../../../server/api/schema';

export interface LocationHourItemTranslations {
  monday: string;
  tuesday: string;
  wednesday: string;
  thursday: string;
  friday: string;
  saturday: string;
  sunday: string;
  closedAllDay: string;
  openAllDay: string;
}

interface LocationHourItemProps {
  hourData: LocationHours;
  translations: LocationHourItemTranslations;
}

// TODO: Update to handle translations
const getDisplayDayOfWeek = (
  locationHoursDayOfWeek: string | undefined,
  translations: LocationHourItemTranslations,
): string => {
  switch (locationHoursDayOfWeek) {
    case 'MONDAY':
      return translations.monday;
    case 'TUESDAY':
      return translations.tuesday;
    case 'WEDNESDAY':
      return translations.wednesday;
    case 'THURSDAY':
      return translations.thursday;
    case 'FRIDAY':
      return translations.friday;
    case 'SATURDAY':
      return translations.saturday;
    case 'SUNDAY':
      return translations.sunday;

    default:
      return '';
  }
};

const getDisplayHoursRange = (
  hourData: LocationHours,
  translations: LocationHourItemTranslations,
): string => {
  if (hourData.closeAllDay) {
    return translations.closedAllDay;
  }

  if (hourData.openAllDay) {
    return translations.openAllDay;
  }

  return hourData.hoursRange || '';
};

const HourItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const LocationHourItem: React.FunctionComponent<LocationHourItemProps> = ({
  hourData,
  translations,
}: LocationHourItemProps) => {
  const { captiontextDefaultNone: captionTextStyle } = useTheme();

  return (
    <HourItemWrapper>
      <div style={captionTextStyle}>
        {getDisplayDayOfWeek(hourData.dayOfWeek, translations)}
      </div>
      <div style={captionTextStyle}>
        {getDisplayHoursRange(hourData, translations)}
      </div>
    </HourItemWrapper>
  );
};

export default withThemeProvider(LocationHourItem, {
  themeTokens: ['captiontextDefaultNone'],
});
